import React from 'react'

import { TtButton, TtIcon } from '@23/react'

import {
  swapVideoFacingMode,
  useCanChangeFacingMode,
} from '../../../Devices/useDevices'
import { VideoTrack } from '../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useLocalParticipant } from '../../../webrtc/webRTCRoom'

import './SecondCamVideoPreview.scss'

const SecondCamVideoPreview = () => {
  const localParticipant = useLocalParticipant()
  const canChangeFacingMode = useCanChangeFacingMode()

  const facingMode =
    localParticipant?.tracks?.mobile?.mediaStream.getSettings().facingMode

  return (
    <div className="second-cam-video-preview" data-facing-mode={facingMode}>
      {localParticipant?.tracks.mobile ? (
        <VideoTrack track={localParticipant.tracks.mobile} objectFit="cover" />
      ) : (
        <TtIcon
          className="second-cam-disabled-icon"
          library="one/webinars"
          name="camera-off"
        />
      )}
      {canChangeFacingMode && (
        <TtButton
          className="second-cam-switch-camera-button"
          variant="light"
          color="secondary"
          circle
          onClick={swapVideoFacingMode}
        >
          <TtIcon library="one/webinars" name="camera-on" />
        </TtButton>
      )}
    </div>
  )
}

export default SecondCamVideoPreview
